// @ts-nocheck
import React, { Component } from 'react'
import { Spinner as OldSpinner } from '../../../LEGACY/elemental'
import { colors } from '@lmc/common/constants'

class Spinner extends Component<any, any> {
  render() {
    return (
      <div
        className={this.props.className}
        style={{ ...styles.container, ...this.props.style }}
      >
        <OldSpinner />
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%',
    textAlign: 'center',
    paddingTop: 100,
    color: colors.darkgrey,
  },
}

export default Spinner
